import { gql } from '@apollo/client';

export const UPDATE_UTILITY_ACCOUNT = gql`
  mutation Flex_UpdateUtilityAccount($id: Int!, $input: UpdateUtilityAccountInput!) {
    updateUtilityAccount(id: $id, input: $input) {
      id
    }
  }
`;
